import core from "@/helpers/client";
const adminuserService = {
  async headVendorListExistAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/vendors/register`,
      params
    );
    return result;
  },
  async createAdminUserAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/users`,
      model
    );
    return result;
  },
};
export default adminuserService;
